/* @bend-expect trellis-tokenized */
import { useCallback, useEffect, useMemo, useState } from 'react';
import { getActiveMark, setMarkCommand } from '../utils/markUtils';
import { FONT_SIZES } from '../constants/fontConstants';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { convertPxStrToPtStr, parseAvailableFontSize } from '../utils/fontUtils';
import { TextToolbarSelect } from 'rich-text-lib/components/editor/TextToolbarSelect';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
export const setFontSize = attrs => setMarkCommand(schema => schema.marks.font_size, attrs);
const sizes = FONT_SIZES.map(size => {
  return {
    text: `${size.points}`,
    value: `${size.points}pt`
  };
});
const getAvailableFontSize = fontSize => `${fontSize && parseAvailableFontSize(fontSize) || FONT_SIZES[0].points}pt`;
export default function FontSizeMark({
  defaultFontSize
}) {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const defaultAvailableSize = useMemo(() => {
    return getAvailableFontSize(defaultFontSize);
  }, [defaultFontSize]);
  const [sizeValue, setSizeValue] = useState(defaultAvailableSize);
  useEffect(() => {
    const activeFontSize = getActiveMark(editorState, editorState.schema.marks.font_size);
    if (activeFontSize) {
      setSizeValue(activeFontSize.attrs.size.endsWith('px') ? convertPxStrToPtStr(activeFontSize.attrs.size) : activeFontSize.attrs.size);
    } else {
      setSizeValue(defaultAvailableSize);
    }
  }, [editorState, setSizeValue, defaultAvailableSize]);
  const applyFontSize = useCallback(evt => {
    setFontSize({
      size: evt.target.value
    })(editorState, tr => {
      const newTr = tr.setMeta('font_size', evt.target.value);
      setEditorState(editorState.apply(newTr));
    });
    setSizeValue(evt.target.value);
  }, [editorState, setEditorState, setSizeValue]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "draftPlugins.sizeStyle.tooltip"
    }),
    children: /*#__PURE__*/_jsx(View, {
      onClick: e => e.stopPropagation(),
      children: /*#__PURE__*/_jsx(TextToolbarSelect, {
        "data-test-id": "size-styles-dropdown",
        onChange: applyFontSize,
        options: sizes,
        value: sizeValue,
        placeholder: I18n.text('hubspot-prosemirror.buttons.fontSizePlaceholder'),
        buttonUse: "transparent",
        maxInlineSize: "min-content"
      })
    })
  });
}